import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getHeaders } from '../../lib/requests';

const RouteClientsModal = ({ isOpen, setIsOpen, routeId }) => {
    const [clients, setClients] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        if (isOpen) {
            fetchClients();
        }
    }, [isOpen, searchQuery]);

    const fetchClients = async () => {
        setIsLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const apiToken = localStorage.getItem('accessToken');
            const params = searchQuery ? { search: searchQuery } : {};

            const response = await axios.get(`${apiUrl}/routes/${routeId}/clients`, {
                headers: getHeaders(apiToken),
                params,
            });
            setClients(response.data.data);
        } catch (error) {
            console.error('Error fetching clients for route', error);
        } finally {
            setIsLoading(false);
        }
    };

    const removeClientFromRoute = async (clientId) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const apiToken = localStorage.getItem('accessToken');
            await axios.delete(`${apiUrl}/routes/${routeId}/clients/${clientId}`, {
                headers: getHeaders(apiToken),
            });
            fetchClients(); // Refresh the clients list after removing
        } catch (error) {
            console.error('Error removing client from route', error);
        }
    };

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <button
                onClick={toggleModal}
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
                View Providers In Route
            </button>

            {isOpen && (
                <>
                    <div className="fixed inset-0 bg-black bg-opacity-35 z-50"></div>
                    <div id="crud-modal" className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-[calc(100%-1rem)] max-h-full">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600">
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                        Providers for Route
                                    </h3>
                                    <button type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" onClick={toggleModal}>
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="p-4">
                                    <input
                                        type="text"
                                        placeholder="Search clients..."
                                        className="mb-4 pl-4 pr-4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    {isLoading ? (
                                        <p>Loading clients...</p>
                                    ) : (
                                        clients.length === 0 ? (
                                            <p>No clients associated with this route.</p>
                                        ) : (
                                            <ul className="max-h-60 overflow-y-auto">
                                                {clients.map((client) => (
                                                    <li key={client.client_id} className="flex justify-between items-center cursor-pointer hover:bg-gray-100 p-2">
                                                        {client.name}
                                                        <button
                                                            onClick={() => removeClientFromRoute(client.client_id)}
                                                            className="text-red-600 hover:text-red-800"
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        )
                                    )}
                                </div>
                                <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
                                    <button onClick={toggleModal} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default RouteClientsModal;
